import StatusCard from '@/elements/StatusCard'
import Flex from '@/elements/Flex'
import { AlertStatuses, type AlertStatusType } from '@/api/types/Alert'

interface StatusSelectorProps {
  selectedStatus: AlertStatusType
  onSelect: (status: AlertStatusType) => void
}

function StatusSelector({ selectedStatus, onSelect }: StatusSelectorProps) {
  return (
    <Flex wfull gap={2}>
      {AlertStatuses.map(status => (
        <button
          key={status}
          onClick={() => onSelect(status)}
          style={{ all: 'unset', width: '100%', cursor: 'pointer' }}
        >
          <StatusCard
            status={status}
            selected={selectedStatus === status}
          />
        </button>
      ))}
    </Flex>
  )
}

export default StatusSelector
